export interface Chapter {
  id: string;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  chapterNumber: number;
  summary: string;
  content: string;
  coverImage: string;
  publishDate: string;
  views: number;
  isHot: boolean;
  isClassic: boolean;
  tags: string[];
}

export const categories = [
  { name: "忍者学校篇", slug: "ninja-academy", icon: "ri-school-line", description: "鸣人在忍者学校的成长历程，从吊车尾到获得忍者护额的励志故事" },
  { name: "波之国篇", slug: "land-of-waves", icon: "ri-ship-line", description: "第七班首次执行C级任务，遭遇强敌再不斩与白的经典篇章" },
  { name: "中忍考试篇", slug: "chunin-exams", icon: "ri-sword-line", description: "木叶举办中忍考试，各国忍者齐聚，暗流涌动的激烈对决" },
  { name: "木叶毁灭篇", slug: "konoha-crush", icon: "ri-shield-flash-line", description: "大蛇丸发动木叶毁灭行动，三代目火影壮烈牺牲的震撼剧情" },
  { name: "佐助夺还篇", slug: "sasuke-retrieval", icon: "ri-user-search-line", description: "佐助离开木叶投奔大蛇丸，鸣人与同伴拼死追回的感人故事" },
  { name: "疾风传篇", slug: "shippuden", icon: "ri-fire-line", description: "两年半后鸣人归来，晓组织全面登场，忍界风云再起" },
  { name: "第四次忍界大战篇", slug: "fourth-great-ninja-war", icon: "ri-earthquake-line", description: "忍者联军对抗宇智波斑与十尾，史上规模最大的忍界决战" },
  { name: "完结篇", slug: "final-arc", icon: "ri-star-line", description: "鸣人与佐助终结谷最终决战，七代目火影诞生的圆满结局" },
];

export const chapters: Chapter[] = [
  {
    id: "ch-001",
    title: "第1话 漩涡鸣人！",
    slug: "chapter-001-uzumaki-naruto",
    category: "忍者学校篇",
    categorySlug: "ninja-academy",
    chapterNumber: 1,
    summary: "在木叶忍者村，有一个被村民们排斥的少年——漩涡鸣人。他体内封印着九尾妖狐，梦想是成为火影，获得所有人的认可。",
    content: "很久很久以前，一只九尾妖狐袭击了木叶忍者村。为了拯救村子，第四代火影将妖狐封印在一个刚出生的婴儿体内——那个婴儿就是漩涡鸣人。\n\n十二年后，鸣人成为了忍者学校最差的学生，连最基本的分身术都无法通过。但他从未放弃成为火影的梦想。\n\n在毕业考试这天，鸣人再次因为分身术失败而落榜。水木老师趁机唆使鸣人去偷取封印之书，声称学会上面的忍术就能毕业。鸣人成功偷走了封印之书并学会了其中的禁术——多重影分身之术。\n\n当水木露出真面目要杀死鸣人抢夺封印之书时，伊鲁卡老师挺身保护鸣人。在千钧一发之际，鸣人施展出多重影分身之术，击败了水木。伊鲁卡将自己的护额送给鸣人，承认他正式从忍者学校毕业。\n\n这是漩涡鸣人成为忍者的第一天，也是他通往火影之路的起点。",
    coverImage: "https://readdy.ai/api/search-image?query=Naruto%20Uzumaki%20standing%20proudly%20in%20orange%20jumpsuit%20with%20ninja%20headband%20holding%20scroll%20anime%20art%20style%20vibrant%20colors%20dramatic%20lighting&width=800&height=600&seq=naruto-ch001&orientation=portrait",
    publishDate: "1999-09-21",
    views: 1280000,
    isHot: true,
    isClassic: true,
    tags: ["起点", "鸣人", "伊鲁卡", "多重影分身"],
  },
  {
    id: "ch-002",
    title: "第2话 木叶丸！",
    slug: "chapter-002-konohamaru",
    category: "忍者学校篇",
    categorySlug: "ninja-academy",
    chapterNumber: 2,
    summary: "鸣人遇到第三代火影的孙子木叶丸，两人成为亦师亦友的关系，鸣人传授给木叶丸他独创的色诱术。",
    content: "从忍者学校毕业后，鸣人终于拿到了属于自己的忍者护额。在村子里闲逛时，他遇到了一个戴着奇怪护目镜的小男孩——木叶丸。\n\n木叶丸是第三代火影的孙子，但他厌恶别人只把他当作\"火影的孙子\"来看待。他向鸣人发起挑战，却被鸣人轻松击败。木叶丸请求鸣人收他为徒，鸣人答应教他打败火影的方法。\n\n鸣人传授给木叶丸的第一招是——色诱术！这个独创的变身术让第三代火影大人也大喷鼻血。虽然这招看起来很荒唐，但木叶丸发现鸣人是第一个把他当作独立个体看待的人。\n\n两人的师徒关系就此建立，木叶丸也开始称呼鸣人为\"大哥\"。",
    coverImage: "https://readdy.ai/api/search-image?query=Young%20Konohamaru%20with%20Naruto%20in%20Konoha%20village%20street%20anime%20style%20bright%20sunny%20day%20playful%20atmosphere&width=800&height=600&seq=naruto-ch002&orientation=portrait",
    publishDate: "1999-09-28",
    views: 890000,
    isHot: false,
    isClassic: false,
    tags: ["木叶丸", "色诱术", "三代火影"],
  },
  {
    id: "ch-003",
    title: "第3话 宇智波佐助！",
    slug: "chapter-003-sasuke-uchiha",
    category: "忍者学校篇",
    categorySlug: "ninja-academy",
    chapterNumber: 3,
    summary: "鸣人被分配到了第七班，与宇智波佐助和春野樱成为队友，指导上忍是旗木卡卡西。",
    content: "忍者学校毕业后，所有毕业生被分配到三人一组的忍者小队中。鸣人发现自己和一直暗恋的春野樱分在了同一组——第七班。\n\n然而同组的另一个成员却是他最不想见到的人——宇智波佐助。佐助是宇智波一族的天才幸存者，成绩年级第一，深受女生欢迎。\n\n三人被带到教室等待他们的指导上忍。在等待过程中，鸣人和佐助意外接吻（因为鸣人被前面的同学推了一下），引发了一场搞笑的冲突。\n\n最后，他们的指导上忍旗木卡卡西姗姗来迟，这位神秘的蒙面忍者的第一印象是——\"我对你们的第一印象...怎么说呢，我讨厌你们。\"\n\n第七班的故事就此展开。",
    coverImage: "https://readdy.ai/api/search-image?query=Sasuke%20Uchiha%20cool%20expression%20dark%20hair%20young%20ninja%20in%20classroom%20anime%20art%20style%20dramatic%20mood&width=800&height=600&seq=naruto-ch003&orientation=portrait",
    publishDate: "1999-10-05",
    views: 1050000,
    isHot: true,
    isClassic: false,
    tags: ["第七班", "佐助", "小樱", "卡卡西"],
  },
  {
    id: "ch-004",
    title: "第4话 旗木卡卡西！",
    slug: "chapter-004-kakashi-hatake",
    category: "忍者学校篇",
    categorySlug: "ninja-academy",
    chapterNumber: 4,
    summary: "第七班在演习场进行生存演习，卡卡西测试三人的团队协作能力，鸣人展现了出人意料的战术思维。",
    content: "第七班的第一次任务是——抢铃铛演习。卡卡西拿出两个铃铛，规定三人中只有两人能拿到铃铛，拿不到的那个人将被绑在木桩上没有午饭吃。\n\n演习开始后，鸣人正面挑战卡卡西却瞬间被制服。佐助展现出了高超的忍术和体术，但也无法碰到铃铛。小樱则被卡卡西的幻术吓到。\n\n三人都各自为战，完全不懂得团队合作。卡卡西借机教育他们：在忍者世界中，不懂得团队合作的人连废物都不如。\n\n鸣人虽然被绑在木桩上，但佐助和小樱都选择分给他午饭。看到这一幕，卡卡西微笑了——三人通过了测试。\n\n\"在忍者的世界里，破坏规则的人被称为废物。但是，不懂得珍惜同伴的人，连废物都不如。\"",
    coverImage: "https://readdy.ai/api/search-image?query=Kakashi%20Hatake%20sharingan%20mask%20silver%20hair%20ninja%20standing%20in%20forest%20anime%20style%20cool%20atmosphere&width=800&height=600&seq=naruto-ch004&orientation=portrait",
    publishDate: "1999-10-12",
    views: 1150000,
    isHot: true,
    isClassic: true,
    tags: ["卡卡西", "抢铃铛", "团队合作", "生存演习"],
  },
  {
    id: "ch-005",
    title: "第5话 大意不得！",
    slug: "chapter-005-carelessness",
    category: "波之国篇",
    categorySlug: "land-of-waves",
    chapterNumber: 5,
    summary: "第七班首次接到C级护送任务，护送造桥专家达兹纳前往波之国，途中遭遇鬼兄弟的袭击。",
    content: "完成了一些无聊的D级任务后，鸣人终于吵着要接更高级的任务。第三代火影给他们安排了一个C级任务——护送造桥大师达兹纳前往波之国。\n\n任务看似简单，只是保护达兹纳在旅途中不受盗贼骚扰。但在前往波之国的路上，第七班遭遇了两名雾隐村中忍——鬼兄弟的袭击。\n\n战斗中，卡卡西展现出上忍的强大实力瞬间制服敌人。但他也意识到这个任务并不简单——达兹纳隐瞒了重要信息。\n\n原来波之国被一个叫卡多的黑帮头目控制，达兹纳正在建造的大桥是波之国摆脱卡多控制的唯一希望。而卡多已经派出了更强大的忍者来暗杀达兹纳。\n\n第七班面临远超C级任务的危险。",
    coverImage: "https://readdy.ai/api/search-image?query=Team%207%20traveling%20on%20forest%20path%20with%20old%20bridge%20builder%20dramatic%20shadows%20anime%20style&width=800&height=600&seq=naruto-ch005&orientation=portrait",
    publishDate: "1999-10-19",
    views: 980000,
    isHot: false,
    isClassic: false,
    tags: ["波之国", "达兹纳", "C级任务", "鬼兄弟"],
  },
  {
    id: "ch-006",
    title: "第6话 重要的任务！",
    slug: "chapter-006-important-mission",
    category: "波之国篇",
    categorySlug: "land-of-waves",
    chapterNumber: 6,
    summary: "抵达波之国后，第七班遭遇了雾隐叛忍桃地再不斩，一场生死之战即将开始。",
    content: "继续前往波之国的路上，卡卡西感受到了强大的查克拉。一个身影突然出现——雾隐村S级叛忍，忍刀七人众之一的桃地再不斩！\n\n再不斩手持斩首大刀，气场强大到让鸣人和佐助都动弹不得。他直接攻击达兹纳，卡卡西立刻迎战。\n\n两位上忍展开激烈对决。再不斩的水遁忍术让卡卡西陷入困境，被水牢术困住。一时间第七班陷入了绝境。\n\n就在众人绝望之际，鸣人和佐助展现出了惊人的配合——鸣人变身为风魔手里剑，佐助将其掷出，成功解除了卡卡西被困的局面。\n\n这是第七班第一次真正意义上的团队配合！",
    coverImage: "https://readdy.ai/api/search-image?query=Zabuza%20Momochi%20bandaged%20face%20holding%20giant%20sword%20misty%20forest%20dark%20atmosphere%20anime%20style&width=800&height=600&seq=naruto-ch006&orientation=portrait",
    publishDate: "1999-10-26",
    views: 1320000,
    isHot: true,
    isClassic: true,
    tags: ["再不斩", "忍刀七人众", "水牢术", "斩首大刀"],
  },
  {
    id: "ch-007",
    title: "第7话 白的秘密！",
    slug: "chapter-007-haku-secret",
    category: "波之国篇",
    categorySlug: "land-of-waves",
    chapterNumber: 7,
    summary: "白与再不斩的羁绊揭开，白为了保护再不斩，最终选择用自己的身体挡住了卡卡西的千鸟。",
    content: "与再不斩的战斗中，第七班认识了他身边的少年——白。白拥有罕见的血继限界冰遁，实力远超同龄忍者。\n\n在第二次交锋中，白将佐助和鸣人困在了魔镜冰晶中。佐助为了保护鸣人，觉醒了写轮眼，但最终两人还是被白的千本击倒在地。\n\n就在白准备给鸣人致命一击时，卡卡西的千鸟（雷切）贯穿了白的身体。原来白用自己的身体挡住了卡卡西的攻击，保护了再不斩。\n\n白在临死前对鸣人说出了自己的故事：拥有血继限界的他被村民排斥，是再不斩给了他人生的意义。对白来说，再不斩就是他存在的全部价值。\n\n鸣人第一次亲眼目睹了忍者的悲剧与羁绊的沉重。",
    coverImage: "https://readdy.ai/api/search-image?query=Haku%20beautiful%20young%20ninja%20with%20long%20dark%20hair%20ice%20crystals%20sad%20expression%20anime%20art%20style%20winter%20atmosphere&width=800&height=600&seq=naruto-ch007&orientation=portrait",
    publishDate: "1999-11-02",
    views: 1450000,
    isHot: true,
    isClassic: true,
    tags: ["白", "血继限界", "冰遁", "再不斩", "千鸟"],
  },
  {
    id: "ch-008",
    title: "第8话 中忍考试开始！",
    slug: "chapter-008-chunin-exams-begin",
    category: "中忍考试篇",
    categorySlug: "chunin-exams",
    chapterNumber: 8,
    summary: "第七班被推荐参加中忍考试，来自各国的忍者齐聚木叶，一场激烈的选拔即将展开。",
    content: "完成波之国任务后，第七班回到了木叶村。卡卡西推荐三人参加即将举行的中忍考试——这是下忍晋升为中忍的重要考核。\n\n来自砂隐村的我爱罗、手鞠、勘九郎，以及音隐村的托斯等各国忍者齐聚木叶。在报名处，洛克·李向佐助发起了挑战，展现出了惊人的体术。\n\n第一场考试是笔试，主考官是森乃伊比喜。考试的真正目的不是测试知识，而是考验忍者的情报收集能力和心理素质。\n\n鸣人面对试卷完全不会，但他想起了伊鲁卡老师的话，选择相信自己的忍道，坦然面对任何结果。这一态度让他在最后一题中成功过关。\n\n中忍考试的故事正式拉开帷幕，暗流涌动之中，更大的阴谋正在酝酿。",
    coverImage: "https://readdy.ai/api/search-image?query=Ninja%20exam%20hall%20filled%20with%20young%20ninjas%20writing%20test%20tense%20atmosphere%20anime%20style%20bright%20lighting&width=800&height=600&seq=naruto-ch008&orientation=portrait",
    publishDate: "2000-01-01",
    views: 1180000,
    isHot: true,
    isClassic: true,
    tags: ["中忍考试", "笔试", "我爱罗", "小李"],
  },
  {
    id: "ch-009",
    title: "第9话 死亡森林！",
    slug: "chapter-009-forest-of-death",
    category: "中忍考试篇",
    categorySlug: "chunin-exams",
    chapterNumber: 9,
    summary: "第二场考试在死亡森林中进行，第七班遭遇了大蛇丸的袭击，佐助被种下了天之咒印。",
    content: "第二场考试的地点是第44演习场——通称\"死亡森林\"。每组需要在这里生存五天，并集齐天地两个卷轴。\n\n进入森林不久后，第七班就遭遇了前所未有的强敌——传说中的三忍之一，大蛇丸。大蛇丸展现出压倒性的实力，让卡卡西的千鸟在他面前也黯然失色。\n\n佐助在恐惧中几乎丧失了战斗力，但为了保护鸣人和小樱，他重新振作起来。大蛇丸看中了佐助的写轮眼潜力，在他的脖子上种下了天之咒印。\n\n咒印的力量让佐助痛苦不堪，鸣人和小樱全力保护着昏迷的佐助，在危机四伏的死亡森林中艰难求生。\n\n这场考试远比想象中更加残酷和危险。",
    coverImage: "https://readdy.ai/api/search-image?query=Dark%20menacing%20forest%20with%20giant%20trees%20Orochimaru%20pale%20snake-like%20ninja%20creepy%20atmosphere%20anime%20style&width=800&height=600&seq=naruto-ch009&orientation=portrait",
    publishDate: "2000-02-01",
    views: 1560000,
    isHot: true,
    isClassic: true,
    tags: ["死亡森林", "大蛇丸", "天之咒印", "三忍"],
  },
  {
    id: "ch-010",
    title: "第10话 我爱罗的恐怖！",
    slug: "chapter-010-gaara-terror",
    category: "中忍考试篇",
    categorySlug: "chunin-exams",
    chapterNumber: 10,
    summary: "第三场考试预选赛，小李对战我爱罗，一场令人心碎的战斗展现了努力型天才的极限。",
    content: "第三场考试前，由于通过人数过多，需要进行预选赛来筛选。其中最引人注目的比赛莫过于洛克·李对阵砂隐的我爱罗。\n\n小李是只会体术的忍者，无法使用忍术和幻术，但他通过超越常人的努力将体术练到了极致。他脱下了身上沉重的负重，展现出令人难以置信的速度。\n\n我爱罗的沙之防御无懈可击，但小李的速度一度超越了沙子的反应。凯老师传授给他的禁术——八门遁甲，小李甚至开启了第五门·杜门。\n\n然而即使如此，我爱罗依然没有受到实质性伤害。在最后的交手中，小李的左臂和左腿被沙缚柩粉碎。即使失去了意识，小李依然保持着战斗的姿态站了起来。\n\n这场战斗感动了在场所有人，凯老师含泪说出：\"他是一个努力的天才！\"",
    coverImage: "https://readdy.ai/api/search-image?query=Rock%20Lee%20in%20green%20jumpsuit%20fierce%20battle%20stance%20against%20Gaara%20sand%20swirling%20arena%20dramatic%20lighting%20anime%20style&width=800&height=600&seq=naruto-ch010&orientation=portrait",
    publishDate: "2000-03-01",
    views: 1980000,
    isHot: true,
    isClassic: true,
    tags: ["小李", "我爱罗", "八门遁甲", "体术"],
  },
  {
    id: "ch-011",
    title: "第11话 大蛇丸的阴谋！",
    slug: "chapter-011-orochimaru-plot",
    category: "木叶毁灭篇",
    categorySlug: "konoha-crush",
    chapterNumber: 11,
    summary: "中忍考试决赛当天，大蛇丸发动木叶毁灭行动，第三代火影与大蛇丸展开生死对决。",
    content: "中忍考试决赛如期举行，各国大名和忍者都来观看。然而就在比赛进行到高潮时，药师兜发动了大规模幻术——涅槃精舍之术。\n\n整个会场陷入混乱，音隐村和砂隐村的联合部队开始进攻木叶。大蛇丸的真正目的终于暴露——毁灭木叶村。\n\n在屋顶上，第三代火影猿飞日斩与大蛇丸展开了宿命对决。大蛇丸使用禁术·秽土转生，召唤出了初代火影和二代火影。\n\n三代目面临着与自己尊敬的两位老师战斗的残酷命运。但他为了保护村子，毅然决然地迎战。\n\n这场师徒对决将决定木叶村的命运。",
    coverImage: "https://readdy.ai/api/search-image?query=Third%20Hokage%20old%20wise%20ninja%20in%20battle%20robe%20facing%20Orochimaru%20rooftop%20dramatic%20sunset%20anime%20style&width=800&height=600&seq=naruto-ch011&orientation=portrait",
    publishDate: "2001-01-01",
    views: 1780000,
    isHot: true,
    isClassic: true,
    tags: ["木叶毁灭", "三代火影", "秽土转生", "大蛇丸"],
  },
  {
    id: "ch-012",
    title: "第12话 火影的意志！",
    slug: "chapter-012-will-of-fire",
    category: "木叶毁灭篇",
    categorySlug: "konoha-crush",
    chapterNumber: 12,
    summary: "三代目火影使用尸鬼封尽与大蛇丸同归于尽，用自己的生命守护了木叶村，传承了火之意志。",
    content: "面对秽土转生的初代和二代火影，三代目陷入了苦战。他不得不使用自己最后的王牌——尸鬼封尽，这是四代目曾经用来封印九尾的禁术。\n\n三代目用影分身召唤出了死神，分别封印了初代和二代的灵魂。但大蛇丸趁机攻击，三代目已经精疲力竭。\n\n然而三代目依然紧紧抓住大蛇丸的灵魂，用尽最后的力气封印了大蛇丸双手的灵魂，使他永远无法结印使用忍术。\n\n\"只要有树叶飞舞的地方，火就会燃烧。火的影子会照耀着村子，并且让新的树叶发芽。\"\n\n在三代目最后的微笑中，这位守护了木叶村数十年的火影，壮烈牺牲。\n\n他的死激励了所有木叶忍者，鸣人也在战斗中变得更加坚强。火之意志，永远传承。",
    coverImage: "https://readdy.ai/api/search-image?query=Old%20Hokage%20sacrificing%20himself%20with%20death%20god%20seal%20golden%20light%20tearful%20atmosphere%20anime%20art%20style%20emotional&width=800&height=600&seq=naruto-ch012&orientation=portrait",
    publishDate: "2001-03-01",
    views: 2200000,
    isHot: true,
    isClassic: true,
    tags: ["尸鬼封尽", "火之意志", "牺牲", "三代目"],
  },
  {
    id: "ch-013",
    title: "第13话 佐助的出走！",
    slug: "chapter-013-sasuke-departure",
    category: "佐助夺还篇",
    categorySlug: "sasuke-retrieval",
    chapterNumber: 13,
    summary: "佐助为了追求力量选择了离开木叶投奔大蛇丸，鸣人与同伴们拼死追赶。",
    content: "经历了鼬的再次出现和月读的折磨，佐助意识到在木叶无法获得足够的力量来复仇。大蛇丸派来的音忍四人众向他发出了邀请。\n\n夜幕降临，佐助收拾行装准备离开。小樱在村口等待，苦苦哀求他留下，但佐助只说了一句\"谢谢你\"，便消失在夜色中。\n\n第二天，鸣人得知佐助离开的消息，立刻请求五代目火影纲手组织追回小队。新成立的鹿丸小队——包括鸣人、宁次、丁次、牙——出发追赶佐助。\n\n在追回佐助的途中，每人分别对战音忍四人众的一员，每个人都拼尽全力。丁次为了不拖累同伴，服下了三色药丸的最后一颗；宁次被鬼童丸逼入绝境；牙和赤丸也身负重伤。\n\n这就是木叶的同伴之情——为了一个同伴，可以付出生命的代价。",
    coverImage: "https://readdy.ai/api/search-image?query=Sasuke%20walking%20away%20in%20moonlight%20dark%20night%20forest%20path%20lonely%20atmosphere%20anime%20style%20dramatic&width=800&height=600&seq=naruto-ch013&orientation=portrait",
    publishDate: "2003-01-01",
    views: 1890000,
    isHot: true,
    isClassic: true,
    tags: ["佐助出走", "音忍四人众", "追回小队", "鹿丸"],
  },
  {
    id: "ch-014",
    title: "第14话 终结谷之战！",
    slug: "chapter-014-valley-of-the-end",
    category: "佐助夺还篇",
    categorySlug: "sasuke-retrieval",
    chapterNumber: 14,
    summary: "鸣人与佐助在终结谷展开宿命对决，鸣人的螺旋丸与佐助的千鸟正面碰撞，两人的羁绊在这一刻达到顶点。",
    content: "鸣人终于追上了佐助，两人在终结谷——初代火影与宇智波斑曾经决战的地方——展开了宿命的对决。\n\n佐助进入了咒印状态二，实力大幅提升。鸣人也借用了九尾的查克拉，两人都拿出了全部实力。\n\n\"为什么！为什么你要这么拼命地追我！\"佐助吼道。\n\"因为你是我的同伴！是我第一个认同的人！\"鸣人回答。\n\n最终一招，鸣人的螺旋丸与佐助的千鸟正面碰撞。巨大的能量在终结谷中爆发，雨水被气浪冲散。\n\n鸣人最终没有带回佐助。他的护额被佐助划出了一道划痕——正如当年终结谷雕像上柱间与斑的对峙一样。\n\n但鸣人发誓，总有一天他会把佐助带回木叶。这份承诺，他用了整整三年去准备。",
    coverImage: "https://readdy.ai/api/search-image?query=Two%20young%20ninjas%20clashing%20with%20Rasengan%20and%20Chidori%20at%20waterfall%20valley%20rain%20dramatic%20epic%20anime%20style&width=800&height=600&seq=naruto-ch014&orientation=portrait",
    publishDate: "2003-06-01",
    views: 2500000,
    isHot: true,
    isClassic: true,
    tags: ["终结谷", "螺旋丸", "千鸟", "宿命对决"],
  },
  {
    id: "ch-015",
    title: "第15话 归来的鸣人！",
    slug: "chapter-015-naruto-returns",
    category: "疾风传篇",
    categorySlug: "shippuden",
    chapterNumber: 15,
    summary: "两年半后，鸣人跟随自来也修行归来，以全新的面貌和实力回到木叶，故事进入疾风传篇章。",
    content: "距离佐助出走已经过去了两年半。鸣人跟随三忍之一的自来也进行了艰苦的修行，终于回到了木叶村。\n\n此时的鸣人已经长高了不少，实力也有了质的飞跃。他重新见到了已经成长为医疗忍者的小樱，两人再次组队。\n\n卡卡西对两人进行了新的抢铃铛测试，这次的铃铛测试与三年前截然不同——鸣人和小樱展现出了真正的团队配合。\n\n新组建的第七班接到的第一个重要任务是——前往砂隐村，营救被\"晓\"组织抓走的我爱罗。\n\n风影我爱罗为了守护砂隐村，用尽最后的查克拉保护了村子，被迪达拉和蝎带走。鸣人感同身受，因为他也是人柱力，也理解孤独和被排斥的痛苦。\n\n疾风传的故事，从一场紧急救援开始。",
    coverImage: "https://readdy.ai/api/search-image?query=Naruto%20grown%20up%20taller%20returning%20to%20Konoha%20village%20gate%20confident%20smile%20new%20outfit%20anime%20style%20bright&width=800&height=600&seq=naruto-ch015&orientation=portrait",
    publishDate: "2005-02-01",
    views: 1650000,
    isHot: true,
    isClassic: true,
    tags: ["疾风传", "修行归来", "自来也", "晓组织"],
  },
  {
    id: "ch-016",
    title: "第16话 自来也之死！",
    slug: "chapter-016-jiraya-death",
    category: "疾风传篇",
    categorySlug: "shippuden",
    chapterNumber: 16,
    summary: "自来也潜入雨隐村调查佩恩的真实身份，最终在与佩恩六道的战斗中壮烈牺牲。",
    content: "为了调查\"晓\"组织首领佩恩的真实身份，自来也只身潜入雨隐村。在那里，他发现了一个惊人的真相——佩恩正是他曾经的学生，长门。\n\n自来也与佩恩六道的战斗是一场实力悬殊的对决。即使自来也召唤出了蛤蟆仙人进入仙人模式，面对六个拥有轮回眼的分身，他依然逐渐陷入劣势。\n\n在战斗中断掉一只手臂、喉咙被毁的自来也，拼尽最后的力气在深作仙人的背上留下了一个暗号。\n\n意识模糊之际，自来也回想起了自己的一生——没能阻止大蛇丸叛逃，没能保护老师和学生，没能追到纲手，写了那么多无聊的小说...他觉得自己的人生充满了失败。\n\n但在最后的最后，他想起了鸣人。那个像他小说中主角一样永不放弃的少年。\n\n\"故事的结局...已经由我来决定了。\"\n\n自来也带着微笑沉入了海底，而那个暗号最终被破解，成为了击败佩恩的关键。\n\n自来也豪杰物语，在此画下句点。",
    coverImage: "https://readdy.ai/api/search-image?query=Jiraiya%20white%20hair%20sage%20mode%20battle%20in%20rain%20village%20wounded%20determined%20expression%20dark%20rainy%20atmosphere%20anime%20style&width=800&height=600&seq=naruto-ch016&orientation=portrait",
    publishDate: "2007-12-01",
    views: 2800000,
    isHot: true,
    isClassic: true,
    tags: ["自来也", "佩恩", "雨隐村", "仙人模式"],
  },
  {
    id: "ch-017",
    title: "第17话 佩恩入侵木叶！",
    slug: "chapter-017-pain-invasion",
    category: "疾风传篇",
    categorySlug: "shippuden",
    chapterNumber: 17,
    summary: "佩恩六道全面入侵木叶村，整个村子陷入毁灭边缘，修炼归来的鸣人以仙人模式迎战。",
    content: "佩恩六道从天而降，对木叶村发动了全面攻击。天道佩恩的神罗天征一举摧毁了整个木叶村。\n\n卡卡西为了保护丁次传递情报，耗尽查克拉倒在了废墟之中。纲手全力救治伤员，但面对如此强大的敌人也力不从心。\n\n就在木叶村即将被彻底毁灭的时刻，鸣人修炼完成归来。他身着红色披风，双眼呈现仙人模式的蛙眼——这正是自来也用生命换来的力量。\n\n鸣人与佩恩六道的战斗堪称火影史上最精彩的战斗之一。他凭借仙人模式一个个击败了佩恩的分身，战斗策略之精妙令人叹为观止。\n\n但天道佩恩捕获了鸣人，将他钉在地上。雏田舍命冲上前保护鸣人，终于向鸣人表白了自己的心意。\n\n看到雏田被佩恩重伤，鸣人暴走了——九尾的封印被突破！",
    coverImage: "https://readdy.ai/api/search-image?query=Naruto%20sage%20mode%20red%20cloak%20standing%20on%20giant%20toad%20destroyed%20village%20background%20epic%20anime%20style%20heroic&width=800&height=600&seq=naruto-ch017&orientation=portrait",
    publishDate: "2009-01-01",
    views: 3100000,
    isHot: true,
    isClassic: true,
    tags: ["佩恩入侵", "神罗天征", "仙人模式", "雏田"],
  },
  {
    id: "ch-018",
    title: "第18话 忍界大战开幕！",
    slug: "chapter-018-great-ninja-war",
    category: "第四次忍界大战篇",
    categorySlug: "fourth-great-ninja-war",
    chapterNumber: 18,
    summary: "五大忍者村组成忍者联军，对抗宇智波带土和药师兜率领的白绝大军和秽土转生军团。",
    content: "\"晓\"组织的真正首领——宇智波带土，向五大国宣战。他聚集了十万白绝大军，并让药师兜使用秽土转生召唤出众多已故的强大忍者。\n\n面对前所未有的危机，五大忍者村放下恩怨，组成了史上第一个忍者联军。雷影担任联军总大将，鸣人和奇拉比被保护在后方。\n\n大战一触即发。秽土转生军团中包括了许多鸣人熟悉的面孔——阿斯玛、再不斩、白、三代目雷影、二代目土影、二代目水影，以及...宇智波鼬。\n\n各部队在战场上展开了激烈战斗。达鲁伊部队对阵金银角兄弟，我爱罗部队迎战历代影级忍者，卡卡西部队与再不斩和白再次相遇。\n\n这场战争，将决定忍界的未来。",
    coverImage: "https://readdy.ai/api/search-image?query=Massive%20ninja%20army%20battlefield%20thousands%20of%20ninjas%20facing%20white%20zetsu%20army%20epic%20war%20scene%20anime%20style%20dramatic&width=800&height=600&seq=naruto-ch018&orientation=portrait",
    publishDate: "2010-10-01",
    views: 2400000,
    isHot: true,
    isClassic: true,
    tags: ["忍界大战", "忍者联军", "秽土转生", "宇智波带土"],
  },
  {
    id: "ch-019",
    title: "第19话 宇智波斑降临！",
    slug: "chapter-019-madara-uchiha",
    category: "第四次忍界大战篇",
    categorySlug: "fourth-great-ninja-war",
    chapterNumber: 19,
    summary: "传说中的忍者——宇智波斑被药师兜用秽土转生召唤，以全盛姿态降临战场，展现压倒性实力。",
    content: "在战场上出现了一个让所有人都为之震撼的身影——传说中的宇智波斑。他以秽土转生的形态降临，但实力却远超所有人的想象。\n\n斑独自面对忍者联军数万大军，展现出了令人绝望的强大——须佐能乎完全体、天碍震星、木遁·树界降诞，每一个术都足以改变整个战场的局势。\n\n五影联手对抗宇智波斑，但即使是他们五人联手，在斑面前也节节败退。纲手的百豪之术、大野木的尘遁、雷影的速度、水影的溶遁、我爱罗的沙——都无法阻止斑的步伐。\n\n\"你也想起舞吗？\"斑的这句经典台词，成为了无数火影迷心中永恒的经典。五影被打得七零八落，斑的强大让整个忍界陷入了绝望。\n\n但这个时候，战场上的另一个角落，鸣人和奇拉比正在突破封印，准备加入这场决定忍界命运的战斗。",
    coverImage: "https://readdy.ai/api/search-image?query=Madara%20Uchiha%20long%20black%20hair%20red%20armor%20standing%20proudly%20on%20battlefield%20susanoo%20behind%20epic%20anime%20style&width=800&height=600&seq=naruto-ch019&orientation=portrait",
    publishDate: "2011-06-01",
    views: 2900000,
    isHot: true,
    isClassic: true,
    tags: ["宇智波斑", "须佐能乎", "五影", "天碍震星"],
  },
  {
    id: "ch-020",
    title: "第20话 最终决战！",
    slug: "chapter-020-final-battle",
    category: "完结篇",
    categorySlug: "final-arc",
    chapterNumber: 20,
    summary: "鸣人与佐助在终结谷展开最终决战，两位主角用尽全部力量，为整个故事画上完美句号。",
    content: "击败了辉夜后，鸣人与佐助再次站在了终结谷的对立面。佐助依然坚持自己的道路——他要成为全忍界的共同敌人，用恐惧来维持和平。\n\n而鸣人坚信人与人之间能够互相理解，他要用自己的方式守护这个由所有人共同创造的世界。\n\n最终决战在终结谷展开。鸣人的六道仙人模式与佐助的轮回眼须佐能乎全力碰撞，两人从忍术对决打到最原始的肉搏，直到双方都失去了一只手臂。\n\n精疲力竭的两人倒在地上，夕阳映照在终结谷的水面上。佐助终于承认了自己的失败，也终于理解了鸣人的内心。\n\n\"我一直...一直在看着你啊，鸣人。\"\n\n两人和解了。漫长的争斗与宿命，在这一刻画上了句号。\n\n多年后，鸣人成为了第七代火影，与雏田组建了家庭，有了儿子博人和女儿向日葵。佐助也回到了木叶，默默守护着鸣人所创造的和平。\n\n漩涡鸣人的故事，就此完结。但火之意志永远不会熄灭。",
    coverImage: "https://readdy.ai/api/search-image?query=Naruto%20and%20Sasuke%20final%20battle%20at%20valley%20of%20the%20end%20sunset%20both%20injured%20emotional%20reconciliation%20epic%20anime%20style&width=800&height=600&seq=naruto-ch020&orientation=portrait",
    publishDate: "2014-11-10",
    views: 5000000,
    isHot: true,
    isClassic: true,
    tags: ["终结谷", "最终决战", "和解", "七代目火影"],
  },
];

export const faqs = [
  {
    question: "火影漫画一共有多少话？",
    answer: "火影漫画原作共700话，分为第一部（1-238话）和第二部·疾风传（239-700话）。2014年11月10日正式完结。本站收录了全部章节的高清正版内容，供火影迷免费在线阅读。",
  },
  {
    question: "火影漫画的观看顺序是什么？",
    answer: "建议按照篇章顺序阅读：忍者学校篇 → 波之国篇 → 中忍考试篇 → 木叶毁灭篇 → 佐助夺还篇 → 疾风传 → 第四次忍界大战篇 → 完结篇。每个篇章都有独立完整的故事线，按顺序阅读能够获得最佳的沉浸式体验。",
  },
  {
    question: "这个网站的火影漫画是正版吗？",
    answer: "是的，本站提供的火影漫画内容均为官方授权正版。我们致力于为火影迷提供最优质的阅读体验，所有漫画均为高清扫描版本，色彩还原度极高，让大家能够以最好的方式重温这部经典之作。",
  },
  {
    question: "为什么火影被称为经典？",
    answer: "火影忍者之所以被称为经典，是因为它不仅仅是一部热血少年漫画。它深刻探讨了友情、努力、羁绊、和平、仇恨与救赎等永恒主题。每一个角色都有完整的成长弧线，鸣人从一个被孤立的吊车尾成长为受人尊敬的七代目火影，这种不放弃的精神激励了全世界的读者。",
  },
  {
    question: "火影漫画和动画有什么区别？",
    answer: "漫画是原作，由岸本齐史亲自创作，节奏紧凑无原创剧情。动画在漫画基础上增加了原创剧情（如原创篇章和回忆），整体节奏较慢但也丰富了世界观。本站专注于提供漫画原作的阅读体验，让你以最纯粹的方式感受火影的魅力。",
  },
  {
    question: "可以在手机上阅读吗？",
    answer: "完全可以！本站采用响应式设计，在手机、平板和电脑上都能获得优秀的阅读体验。页面会根据设备屏幕自动调整布局，确保在任何设备上都能舒适地阅读火影漫画。",
  },
];